module.exports = __webpack_public_path__ + "938e9bfffa4717479d32ce469b8832c9.jpg";